import { obtenirUrlControleur } from '../utils/urlUtils';
import Region from '../modeles/Region';
import { List } from 'immutable';
import fetch, { jsonHeaders } from '../utils/fetch';
import { RegionDto } from '../modeles/RegionDto';
import { ReponseRegionDto } from '../modeles/ReponseRegionDto';

const lienRegion = obtenirUrlControleur('region');
const routeRegion = `${lienRegion}/api/Region`;

const mapperRegion = (region: ReponseRegionDto) => new Region({
    id: region.id,
    nom: region.nom
});

export default class RegionApi {
    static async obtenirToutesLesRegions(): Promise<List<Region>> {
        return await fetch(`${routeRegion}/regions`, { method: 'GET' })
            .then((regions) => List((Array.isArray(regions) ? (regions as ReponseRegionDto[]) : []).map(mapperRegion)));
    }

    static async obtenirRegionCourante(regionId: string): Promise<Region> {
        return await fetch(`${routeRegion}/region/${regionId}`, { method: 'GET' })
            .then((region) => mapperRegion(region as ReponseRegionDto));
    }

    static async ajouterRegion(region: RegionDto): Promise<void> {
        await fetch(`${routeRegion}/ajouter`, {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify(region)
        });
    }

    static async modifierRegion(id: string, region: RegionDto): Promise<void> {
        await fetch(`${routeRegion}/region/${id}`, {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(region)
        });
    }

    static async supprimerRegion(id: string): Promise<void> {
        await fetch(`${routeRegion}/region/${id}`, {
            method: 'DELETE',
            headers: jsonHeaders,
        });
    }
}